var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpMsg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 2.6665L6.77678 6.4768C7.21756 6.78535 7.43795 6.93962 7.67767 6.99938C7.88943 7.05216 8.1109 7.05216 8.32265 6.99938C8.56238 6.93962 8.78277 6.78535 9.22355 6.4768L14.6668 2.6665M4.5335 11.3332H11.4668C12.5869 11.3332 13.147 11.3332 13.5748 11.1152C13.9511 10.9234 14.2571 10.6175 14.4488 10.2412C14.6668 9.81333 14.6668 9.25328 14.6668 8.13317V3.8665C14.6668 2.7464 14.6668 2.18635 14.4488 1.75852C14.2571 1.3822 13.9511 1.07624 13.5748 0.884491C13.147 0.666504 12.5869 0.666504 11.4668 0.666504H4.5335C3.41339 0.666504 2.85334 0.666504 2.42552 0.884491C2.04919 1.07624 1.74323 1.3822 1.55148 1.75852C1.3335 2.18635 1.3335 2.7464 1.3335 3.8665V8.13317C1.3335 9.25328 1.3335 9.81333 1.55148 10.2412C1.74323 10.6175 2.04919 10.9234 2.42552 11.1152C2.85334 11.3332 3.41339 11.3332 4.5335 11.3332Z",
    stroke: "#667085",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpMsg);
export default __webpack_public_path__ + "static/media/help-msg.5ae056b7d1052f9dce0914d4903e4248.svg";
export { ForwardRef as ReactComponent };